import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import { MdOutlineBarChart, MdOutlineHistory, MdOutlineMap, MdOutlineRocketLaunch, MdOutlineSummarize, MdOutlineViewKanban } from "react-icons/md";

import Backlog from "./backlog";
import Roadmap from "./roadmap";
import Report from "./report";
import Stats from "./stats";
import History from "./history";
import { BiPlus } from "react-icons/bi";
import Builder from "./Builder";

// Custom tooltip component
const Tooltip = ({ text, children }) => {
  return (
    <div className="group relative z-50 flex items-center">
      {children}
      <div className="absolute left-full ml-2 w-auto min-w-max origin-left scale-0 rounded-md bg-gray-800 p-2 text-xs text-white shadow-md transition-all duration-100 group-hover:scale-100">
        {text}
      </div>
    </div>
  );
};

const Roadlog = ({ project, setProject }) => {
  const [view, setView] = useState("BACKLOG");
  const [showRoadmap, setShowRoadmap] = useState(false);
  const navigate = useNavigate();

  const { tab } = useParams();

  useEffect(() => {
    if (tab === "stats") return setView("STATS");
    if (tab === "report") return setView("REPORT");
    if (tab === "history") return setView("HISTORY");
    if (tab === "backlog") return setView("BACKLOG");
    if (tab === "builder") return setView("BUILDER");
    if (tab === "roadmap") return setView("ROADMAP");
    setView("BACKLOG");
  }, [tab]);

  return (
    <div className="flex flex-col h-[calc(100vh-120px)] relative">
      <div className="flex gap-1 w-full h-full overflow-hidden">
        <div className="py-4 pb-8 pr-2 flex flex-col items-center gap-6 border-r border-gray-200">
          <button
            className={`p-1 rounded-md transition-colors ${view === "BACKLOG" ? "bg-blue-100 text-blue-600" : "text-gray-700 hover:bg-gray-100"}`}
            onClick={() => navigate(`/project/${project._id}/roadlog/backlog`)}>
            <Tooltip text="Backlog">
              <MdOutlineViewKanban className="w-5 h-5" />
            </Tooltip>
          </button>
          <button
            className={`p-1 rounded-md transition-colors ${view === "ROADMAP" ? "bg-blue-100 text-blue-600" : "text-gray-700 hover:bg-gray-100"}`}
            onClick={() => navigate(`/project/${project._id}/roadlog/roadmap`)}>
            <Tooltip text="Roadmap">
              <MdOutlineMap className="w-5 h-5" />
            </Tooltip>
          </button>
          <button
            className={`p-1 rounded-md transition-colors ${view === "REPORT" ? "bg-blue-100 text-blue-600" : "text-gray-700 hover:bg-gray-100"}`}
            onClick={() => navigate(`/project/${project._id}/roadlog/report`)}>
            <Tooltip text="Rapport">
              <MdOutlineSummarize className="w-5 h-5" />
            </Tooltip>
          </button>
          <button
            className={`p-1 rounded-md transition-colors ${view === "BUILDER" ? "bg-blue-100 text-blue-600" : "text-gray-700 hover:bg-gray-100"}`}
            onClick={() => navigate(`/project/${project._id}/roadlog/builder`)}>
            <Tooltip text="Builder">
              <MdOutlineRocketLaunch className="w-5 h-5" />
            </Tooltip>
          </button>
          <button
            className={`p-1 rounded-md transition-colors ${view === "STATS" ? "bg-blue-100 text-blue-600" : "text-gray-700 hover:bg-gray-100"}`}
            onClick={() => navigate(`/project/${project._id}/roadlog/stats`)}>
            <Tooltip text="Statistiques">
              <MdOutlineBarChart className="w-5 h-5" />
            </Tooltip>
          </button>
          <button
            className={`p-1 rounded-md transition-colors ${view === "HISTORY" ? "bg-blue-100 text-blue-600" : "text-gray-700 hover:bg-gray-100"}`}
            onClick={() => navigate(`/project/${project._id}/roadlog/history`)}>
            <Tooltip text="Historique">
              <MdOutlineHistory className="w-5 h-5" />
            </Tooltip>
          </button>
        </div>
        <div className="flex-grow h-full overflow-hidden">
          {view === "BACKLOG" && <Backlog project={project} showRoadmap={showRoadmap} setShowRoadmap={setShowRoadmap} />}
          {view === "STATS" && (
            <div className="h-full overflow-auto">
              <Stats project={project} />
            </div>
          )}
          {view === "REPORT" && (
            <div className="h-full overflow-auto">
              <Report project={project} />
            </div>
          )}
          {view === "HISTORY" && (
            <div className="h-full overflow-auto">
              <History project={project} />
            </div>
          )}
          {view === "ROADMAP" && (
            <div className="h-full overflow-auto">
              <Roadmap
                project={project}
                setProject={setProject}
                onSwitchBacklog={() => {
                  navigate(`/project/${project._id}/roadlog/backlog`);
                  setShowRoadmap(true);
                }}
              />
            </div>
          )}
          {view === "BUILDER" && (
            <div className="h-full overflow-auto">
              <Builder project={project} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Roadlog;
